/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentCategory
 */
export interface TournamentCategory {
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    gender?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCategory
     */
    birthDateMin?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TournamentCategory
     */
    birthDateMax?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    maxTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    periods?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    periodTime?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategory
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    minPlayers?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategory
     */
    maxPlayers?: number;
}

/**
 * Check if a given object implements the TournamentCategory interface.
 */
export function instanceOfTournamentCategory(value: object): value is TournamentCategory {
    return true;
}

export function TournamentCategoryFromJSON(json: any): TournamentCategory {
    return TournamentCategoryFromJSONTyped(json, false);
}

export function TournamentCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'name': json['name'] == null ? undefined : json['name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthDateMin': json['birthDateMin'] == null ? undefined : (new Date(json['birthDateMin'])),
        'birthDateMax': json['birthDateMax'] == null ? undefined : (new Date(json['birthDateMax'])),
        'maxTeams': json['maxTeams'] == null ? undefined : json['maxTeams'],
        'periods': json['periods'] == null ? undefined : json['periods'],
        'periodTime': json['periodTime'] == null ? undefined : json['periodTime'],
        'description': json['description'] == null ? undefined : json['description'],
        'minPlayers': json['minPlayers'] == null ? undefined : json['minPlayers'],
        'maxPlayers': json['maxPlayers'] == null ? undefined : json['maxPlayers'],
    };
}

export function TournamentCategoryToJSON(json: any): TournamentCategory {
    return TournamentCategoryToJSONTyped(json, false);
}

export function TournamentCategoryToJSONTyped(value?: TournamentCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'name': value['name'],
        'gender': value['gender'],
        'birthDateMin': value['birthDateMin'] == null ? value['birthDateMin'] : value['birthDateMin'].toISOString().substring(0,10),
        'birthDateMax': value['birthDateMax'] == null ? value['birthDateMax'] : value['birthDateMax'].toISOString().substring(0,10),
        'maxTeams': value['maxTeams'],
        'periods': value['periods'],
        'periodTime': value['periodTime'],
        'description': value['description'],
        'minPlayers': value['minPlayers'],
        'maxPlayers': value['maxPlayers'],
    };
}

